import React from "react"
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom"

import { useStateValue } from "../_shared/context/AppStateStore"
import NotFound from "../_shared/components/NotFound"

import LoggedApp from "./LoggedApp"
import AuthPage from "./AuthPage"

//------------------------------------------------------------------------------

function RoutedApp(props) {
  const [{ user }] = useStateValue()


  let routedContent = null

  if (user) {
    routedContent = (
      <Routes>
        <Route path="/auth/*" element={<Navigate to="/" />} />
        <Route path="/*" element={<LoggedApp key="logged" />} />
      </Routes>
    )
  } else {
    routedContent = (
      <Routes>
        <Route path="*" element={<Navigate to="/auth" />} />
        <Route path="/auth/*" element={<AuthPage key="auth" />} />
      </Routes>
    )
  }


  return <Router>{routedContent}</Router>

}


// ----------------------------------------------------------------------------

export default RoutedApp
